import React, { useEffect, useState } from 'react';
import { Divider, Stack, Typography, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import SignalWifiStatusbarConnectedNoInternet4Icon from '@mui/icons-material/SignalWifiStatusbarConnectedNoInternet4';
import SignalWifiStatusbar4BarIcon from '@mui/icons-material/SignalWifiStatusbar4Bar';

export default function NoInternet({open, onClose, isOnline }) {

    const handleClose = () => {
        onClose();
    };

    return (
        <React.Fragment>

        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
            Internet Connection
            </DialogTitle>
            <DialogContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",     // horizontal centering
                justifyContent: "center", // vertical centering
              }}
            >
              {isOnline ?
              <SignalWifiStatusbar4BarIcon fontSize='large' color='primary' />
              :
              <SignalWifiStatusbarConnectedNoInternet4Icon fontSize='large' color='error' />
              }
              <Typography textAlign={'right'} variant='body2'>{isOnline ? 'Internet connection restored' : 'No Internet connection'}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}